// extracted by mini-css-extract-plugin
export var endRoundContainer = "EndRound-module--endRoundContainer--221Lp";
export var whoLost = "EndRound-module--whoLost--2hLmo";
export var playersContainer = "EndRound-module--playersContainer--pme54";
export var player = "EndRound-module--player--aixvg";
export var playerNow = "EndRound-module--playerNow--3Q9DM";
export var icon = "EndRound-module--icon--2dAk8";
export var playerNotNow = "EndRound-module--playerNotNow--1UrMc";
export var proceedButton = "EndRound-module--proceedButton--2ojwm";